import { SimpleGrid, Stack } from "@chakra-ui/react";
import { Button } from "@headlessui/react";
import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { useRouter } from "next/router";
import YouTube from "react-youtube";

const HeroBlok = ({ blok }) => {
  const router = useRouter();
  return (
    <SimpleGrid
      bgImage={blok.backgroundImage.filename}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      bgColor={blok.backgroundColor}
      columns={[1, 1, 2]}
      spacing={10}
      px={[3, blok.pageMargins ? "10%" : 10]}
      py={10}
      h={"fit-content"}
      mb={10}
      alignItems="center"
      {...storyblokEditable(blok)}
    >
      <Stack
        justifyContent="center"
        alignItems={["center", "flex-start"]}
        flex={2}
      >
        {blok.body &&
          blok.body.map((nestedBlok) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
      </Stack>
      <Stack>
        {blok.videoId && (
          <YouTube opts={{ width: "100%" }} videoId={blok.videoId} />
        )}
        {blok.therapistPageName && (
          <div className="flex flex-row justify-center mt-3">
            <Button
              onClick={() => router.push(`/counsellors/${blok.therapistPageName}`)}
                className="rounded-full px-3 py-1.5 text-brand cursor-pointer font-bold bg-white hover:bg-white/90 transition"
              >
              View therapist
            </Button>
          </div>
        )}
      </Stack>

    </SimpleGrid>
  );
};

export default HeroBlok;
